import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {animate, sequence, style, transition, trigger} from "@angular/animations";

import {NewNavigationService} from "@shared/services/new-navigation.service";

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styles: [],
  animations: [
    trigger('openClose', [
      transition(":enter", [style({transform: 'translateX(264px)'}), animate('0.1s')]),
      transition(":leave", [sequence([style({right: '0px'}), animate('0.1s', style({right: '-264px'}))])]),
    ])
  ]
})
export class ProfileComponent implements OnInit, OnChanges {

  @Input() isVisible = false;

  isPasswordChangeVisible = false;
  wasPasswordChanged = false;
  isAccountDataVisible = false;
  messageIntervalWidthPercent = 0;

  constructor(
    private newNavigationService: NewNavigationService,
  ) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    // zmiana wybranego modułu
    this.isPasswordChangeVisible = !this.isVisible;
  }

  ngOnInit(): void {
  }

  onNavigateToPasswordChange() {
    this.isPasswordChangeVisible = !this.isPasswordChangeVisible;
  }

  public onRedirectToAccountData(): void {
    this.isAccountDataVisible = true;
  }

  onNavigateToMain() {
    this.newNavigationService.toMainPanel();
  }

  onLogout() {
    this.newNavigationService.toLogout();
  }

  onPasswordChanged(passwordChanged: boolean) {
    this.isPasswordChangeVisible = false;
    this.wasPasswordChanged = passwordChanged;
    this.runMessageInterval();
  }

  private runMessageInterval() {
    this.messageIntervalWidthPercent = 100;

    const interval = setInterval(() => {
      if (this.messageIntervalWidthPercent <= 0) {
        this.messageIntervalWidthPercent = 0;
        this.wasPasswordChanged = false;
        clearInterval(interval);
        return;
      }
      this.messageIntervalWidthPercent -= 1;
    }, 100);
  }

}
